import { api } from '../../libs/api'

export default {
  namespaced: true,
  state: {
    index: [],
    hasRecentNews: false,
  },
  mutations: {
    setIndex (state, news) {
      state.index = news
    },
    setHasRecentNews (state, hasRecentNews) {
      state.hasRecentNews = hasRecentNews
    },
    setRead (state, id) {
      state.index = state.index.map((news) => {
        if (news.id !== id) return news
        return Object.assign({}, news, { is_read: true, is_recent_unread: false })
      })
      state.hasRecentNews = state.index.some(news => news.is_recent_unread)
    },
  },
  actions: {
    async fetchIndex ({ commit }, payload = {}) {
      const { oemIdentifier } = payload

      const res = await api.fetchNews({
        oem_identifier: oemIdentifier || null,
      })

      commit('setIndex', res)
    },
    async fetchRecent ({ commit }, payload = {}) {
      const { oemIdentifier } = payload

      const res = await api.fetchRecentNews({
        oem_identifier: oemIdentifier || null,
      })

      commit('setHasRecentNews', !!res.has_recent_news)
    },
    async read ({ commit }, payload = {}) {
      const { id, oemIdentifier } = payload

      await api.readNews(id, {
        oem_identifier: oemIdentifier || null,
      })

      commit('setRead', id)
    },
  },
  getters: {
    index: state => state.index,
    hasRecentNews: state => state.hasRecentNews,
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/news.js